module.exports = __webpack_public_path__ + "static/img/Slide-2.54bbb77.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Slide-2.webp
// module id = +Wxg
// module chunks = 0